import React from 'react';
import ServiceDetailPage from './ServiceDetailPage';
export default function KitchenRemodelingMiami() {
  return <ServiceDetailPage slug="kitchen-remodeling-miami" />;
}
